import { IDocumentsFormValues, TUploadType } from '@/types/uploader'
import { z } from 'zod'

const requiredField = (fieldName: string) =>
  z.array(z.any()).min(1, `${fieldName} اجباری است`)

const baseSchema = z.object({
  BUSINESS_LOGO: requiredField('لوگوی کسب‌وکار'),
  NATIONAL_ID_CARD: requiredField('روی کارت ملی'),
  NATIONAL_ID_CARD_BACK_SIDE: requiredField('پشت کارت ملی'),
  BIRTH_CERTIFICATE: requiredField('شناسنامه'),
  TAX_REGISTRATION_CERTIFICATE: requiredField('گواهی ثبت مالیاتی'),
  uploadType: z.enum(['individual', 'legal'], {
    required_error: 'لطفا نوع ثبت را انتخاب کنید'
  })
})

const individualUploadSchema = z.object({
  BUSINESS_LICENSE: requiredField('جواز کسب')
})

const legalUploadSchema = z.object({
  OFFICIAL_NEWSPAPER: requiredField('روزنامه رسمی'),
  COMPANY_ARTICLES_OF_ASSOCIATION: requiredField('اساسنامه شرکت')
})
export const createDocumentDynamicSchema = (
  values: IDocumentsFormValues & { uploadType: TUploadType }
) => {
  return values.uploadType === 'individual'
    ? baseSchema.merge(individualUploadSchema)
    : baseSchema.merge(legalUploadSchema)
}
